import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class AwsLoginService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    }),
  };

  //iniciar sesion
  signIn(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/authentication/signIn`, body, this.httpOptionsNew);
  }

  //Registrar nuevo admin
  registerAdmin(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/authentication/signUp`, body, this.httpOptionsNew);
  }

  //solicitar cambio de contraseña
  forgotPassword(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/authentication/forgotPassword`, body, this.httpOptionsNew);
  }

  //actualizar contraseña
  confirmNewPass(body){
    return this.http.put(`${environment.baseUrlAPIPlatform}/authentication/confirmNewPassword`, body, this.httpOptionsNew);
  }

  //verificar cuenta de usuario
  verified(body) {
    return this.http.post(`${environment.baseUrlAPIPlatform}/authentication/verifyAccount`, body, this.httpOptionsNew);
  }

  //reenviar codigo de verificacion
  resendCodeVerified(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/authentication/resendConfirmationCode`, body, this.httpOptionsNew);
  }

  //cerrar sesion
  logout(){
    return this.http.post(`${environment.baseUrlAPIPlatform}/authentication/logoutUser`, {}, {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    }),
  });
  }
}
